// payment index for paid client
import React from 'react'
import { Route } from 'react-router-dom'

import PaymentAdd from './PaymentAdd'
import PaymentList from './PaymentList'
import Payment from './Paymentuser'
import PaymentEdit from './PaymentEdit'

import { Root } from '../../shared/styles'
import { ROUTES } from '../../shared/constants'

export default () =>
  <Root>
    <Route exact path={ROUTES.PAYMENT} component={PaymentList} />
    <Route exact path={ROUTES.PAYMENT_ADD} component={PaymentAdd} />
    <Route exact path={ROUTES.PAYMENT_EDIT} component={PaymentEdit} />
    <Route exact path={ROUTES.PAYMENT_USERS} component={Payment} />
  </Root>

export { PaymentAdd, PaymentList }
